import userRoleService from "src/utils/userRoles.service";

function hasAccess(type) {
  switch (type) {
    case "hub":
      return userRoleService.canAccessHub();

    case "content-map":
      return userRoleService.canAccessContentMap();

    case "search":
      return userRoleService.canAccessSearch();

    case "collections":
      return userRoleService.canAccessCollection();

    case "stream":
      return userRoleService.canAccessHub();

    case "conversations":
      return userRoleService.canShare();

    case "reports":
      return userRoleService.canAccessReport();

    case "engage":
      return userRoleService.canAccessEngage();

    case "integrations":
      return userRoleService.canShare();

    case "user-management":
      return userRoleService.canAccessUserManagement();

    case "viewer-settings":
      return userRoleService.canAccessPromoteSettings();

    case "hub-settings":
      return userRoleService.canEditLayout();

    case "custom-fields":
      return userRoleService.canAccessCustomFields();

    case 'coaching':
      return userRoleService.canAccessCoaching();
      
    case "privacy-policy":
      return userRoleService.canAccessPrivacyPolicyControl();

    case "stream-access-management":
      return (
        userRoleService.canAccessHub() && userRoleService.canCreateStream()
      );

    case "nda-template":
      return userRoleService.canAccessNdaTemplates();

    case "email-template":
      return userRoleService.canAccessEmailTemplates();

    case "distribution-lists":
      return userRoleService.canAccessDistributionLists();

    case "data-sources":
      return userRoleService.canAccessDataSource();

    default:
      return true;
  }
}

export default hasAccess;
